import { create } from 'zustand';

const useUserBuffStore = create((set, get) => ({
    // Store structure: { targetId: [buffArray] }
    userBuffs: {},
    
    // Add or update a buff for a specific target
    addBuff: (targetId, buff) => {
        set((state) => {
            const currentBuffs = state.userBuffs[targetId] || [];
            
            // Check if buff already exists (by uuid), if so update it
            const existingIndex = currentBuffs.findIndex(b => b.uuid === buff.uuid);
            
            let newBuffs;
            if (existingIndex !== -1) {
                // Update existing buff
                newBuffs = [...currentBuffs];
                newBuffs[existingIndex] = buff;
            } else {
                // Add new buff
                newBuffs = [...currentBuffs, buff];
            }
            
            return {
                userBuffs: {
                    ...state.userBuffs,
                    [targetId]: newBuffs
                }
            };
        });
    },
    
    // Remove a buff by uuid from a specific target
    removeBuff: (targetId, uuid) => {
        set((state) => {
            const currentBuffs = state.userBuffs[targetId] || [];
            const filteredBuffs = currentBuffs.filter(buff => buff.uuid !== uuid);
            
            if (filteredBuffs.length === 0) {
                // Remove the targetId key if no buffs remain
                const newUserBuffs = { ...state.userBuffs };
                delete newUserBuffs[targetId];
                return { userBuffs: newUserBuffs };
            }
            
            return {
                userBuffs: {
                    ...state.userBuffs,
                    [targetId]: filteredBuffs
                }
            };
        });
    },
    
    // Get all buffs for a specific target
    getBuffs: (targetId) => {
        const state = get();
        return state.userBuffs[targetId] || [];
    },
    
    // Clear all buffs (useful for disconnect/reconnect)
    clearAllBuffs: () => {
        set({ userBuffs: {} });
    },
    
    // Get remaining time for a buff (in milliseconds)
    getBuffRemainingTime: (buff) => {
        const now = Date.now();
        const remaining = buff.expirationTime - now;
        return Math.max(0, remaining);
    },
    
    // Format remaining time for display
    formatRemainingTime: (buff) => {
        const remaining = get().getBuffRemainingTime(buff);
        if (remaining <= 0) return "Expired";
        
        const seconds = Math.ceil(remaining / 1000);
        if (seconds < 60) return `${seconds}s`;
        
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
    }
}));

export default useUserBuffStore; 